var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatchwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 0C13.8965 0 12.5 1.39648 12.5 3.125C12.5 4.85352 13.8965 6.25 15.625 6.25H17.1875V9.60938C7.45117 11.1133 0 19.5312 0 29.6875C0 40.9082 9.0918 50 20.3125 50C31.5332 50 40.625 40.9082 40.625 29.6875C40.625 25.6055 39.4238 21.8066 37.3535 18.6328L39.707 16.2793C40.9277 15.0586 40.9277 13.0762 39.707 11.8555C38.4863 10.6348 36.5039 10.6348 35.2832 11.8555L33.1738 13.9648C30.4297 11.7188 27.0996 10.1758 23.4375 9.60938V6.25H25C26.7285 6.25 28.125 4.85352 28.125 3.125C28.125 1.39648 26.7285 0 25 0H20.3125H15.625ZM22.6562 18.75V31.25C22.6562 32.5488 21.6113 33.5938 20.3125 33.5938C19.0137 33.5938 17.9688 32.5488 17.9688 31.25V18.75C17.9688 17.4512 19.0137 16.4062 20.3125 16.4062C21.6113 16.4062 22.6562 17.4512 22.6562 18.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatchwhite);
export default __webpack_public_path__ + "static/media/stopwatch white.5c3b436e643e0bc9116cd326694fc382.svg";
export { ForwardRef as ReactComponent };